import Vue from 'vue'
import axios from 'axios'
import store from '@/stores'

//接口地址
// axios.defaults.baseURL = ''
// axios.defaults.baseURL = 'https://dataapi.gas.cn/'
axios.defaults.baseURL = 'https://gaiaapi.gasgoo.com/'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// static_json_path
const static_json_path = 'https://c1.gasgoo.com/forecast/'
let date = new Date();
let time_stamp = date.getFullYear() + '_' + (date.getMonth() + 1) + '_' + date.getDate()
axios.interceptors.request.use(config => {
  // 游客
  // if (store.state.userId === 0) {
  switch (config.url) {
    case "/home/timenode":
      config.url = static_json_path + 'time_node.json?v=' + time_stamp;
      config.params = {};
      return config;
    case "/home/init":
      if (config.params.year === store.state.year && config.params.month === store.state.month) {
        config.url = static_json_path + (config.params.queryType === 'production' ? 'init_production.json' : 'init_sales.json') + '?v=' + time_stamp;
        config.params = {};
        return config;
      }
      break;
    case "/forecast/condition":
      if (config.params.bodyType === "[]"
        && config.params.brandId === ""
        && config.params.brandOriginId === ""
        && config.params.manufacturerId === ""
        && config.params.propulsionTypeId === "") {
        config.url = static_json_path + 'forecast_condition.json?v=' + time_stamp;
        config.params = {};
        return config;
      }
      break;
    case "/forecast/barYOY":
      date.setFullYear(store.state.time_node.getFullYear());
      date.setMonth(store.state.time_node.getMonth() - 11);
      if (config.params.startYear === date.getFullYear()
        && config.params.startMonth === date.getMonth() + 1
        && config.params.endYear === store.state.year
        && config.params.endMonth === store.state.month
        && config.params.bodyType === "[]"
        && config.params.brandId === ""
        && config.params.brandOriginId === ""
        && config.params.manufacturerId === ""
        && config.params.model === ""
        && config.params.propulsionTypeId === ""
        && config.params.timeType === "month") {
        config.url = static_json_path + (config.params.queryType === 'production' ? 'baryoy_production.json' : 'baryoy_sales.json') + '?v=' + time_stamp;
        config.params = {};
        return config;
      }
      break;
    case "/forecast/table":
      date.setFullYear(store.state.time_node.getFullYear());
      date.setMonth(store.state.time_node.getMonth() - 11);
      if (config.params.startYear === date.getFullYear()
        && config.params.startMonth === date.getMonth() + 1
        && config.params.endYear === store.state.year
        && config.params.endMonth === store.state.month
        && config.params.bodyType === "[]"
        && config.params.brandId === ""
        && config.params.brandOriginId === ""
        && config.params.manufacturerId === ""
        && config.params.model === ""
        && config.params.propulsionTypeId === ""
        && config.params.tableTimeType === "month"
        && config.params.pageIndex === 1) {
        config.url = static_json_path + (config.params.queryType === 'production' ? 'forecast_table_production.json' : 'forecast_table_sales.json') + '?v=' + time_stamp;
        config.params = {};
        return config;
      }
      break;
    case "/region/condition":
      if (config.params.provienceId === 0
        && config.params.cityId === 0
        && config.params.manufacturerId === 0) {
        config.url = static_json_path + 'map_condition.json?v=2' + time_stamp;
        config.params = {};
        return config;
      }
      break;
    case "/region/init":
      config.url = static_json_path + (config.params.isCapacity === true ? 'map_init_capacity.json' : 'map_init_production.json') + '?v=' + time_stamp;
      config.params = {};
      return config;
    case "/region/filter":
      if (config.params.provienceId === 0
        && config.params.cityId === 0
        && config.params.manufacturerId === 0) {
          if(config.params.isCapacity === 1 && config.params.startYear === store.state.year - 2 && config.params.endYear === store.state.year - 1){
            config.url = static_json_path + 'map_filter_capacity.json' + '?v=' + time_stamp;
            config.params = {};
            return config;
          }
          if(config.params.isCapacity === 0 && config.params.startYear === store.state.year - 3 && config.params.endYear === store.state.year - 1){
            config.url = static_json_path + 'map_filter_production.json' + '?v=' + time_stamp;
            config.params = {};
            return config;
          }
      }
      break;
    case "/rank/condition":
      config.url = static_json_path + 'rank_condition.json?v=' + time_stamp;
      config.params = {};
      return config;
    case "/rank/filter":
      if (config.params.year === store.state.year
        && config.params.month === store.state.month
        && config.params.bodyType === "[]"
        && config.params.brandOriginId === ""
        && config.params.propulsionTypeId === "") {
        config.url = static_json_path + (config.params.type === 'production' ? 'rank_filter_production_' + config.params.queryType + '.json' : 'rank_filter_sales_' + config.params.queryType + '.json') + '?v=' + time_stamp;
        config.params = {};
        return config;
      }
      break;
    case "/rank/filtertable":
      if (config.params.year === store.state.year
        && config.params.month === store.state.month
        && config.params.bodyType === "[]"
        && config.params.brandOriginId === ""
        && config.params.propulsionTypeId === ""
        && config.params.pageIndex === 1
        && config.params.pageSize === 10) {
        config.url = static_json_path + (config.params.type === 'production' ? 'rank_filter_table_production_' + config.params.queryType + '_' + config.params.previousMonth + '.json' : 'rank_filter_table_sales_' + config.params.queryType + '_' + config.params.previousMonth + '.json') + '?v=' + time_stamp;
        config.params = {};
        return config;
      }
      break;
    case "/outputvalue/condition":
      if (config.params.manufacturerId === ""
        && config.params.brandId === ""
        && config.params.model === ""
        && config.params.programCode === "") {
        config.url = static_json_path + 'outputvalue_condition.json?v=' + time_stamp;
        config.params = {};
        return config;
      }
      break;
  }
  //   console.log(config)
  // }
  // 公用


  // 登录状态
  if (config.params) {
    config.params.userId = store.state.userId;
    config.params.token = store.state.token;
    config.params.time_stamp = store.state.time_stamp;
  } else {
    config.params = {
      userId: store.state.userId,
      token: store.state.token,
      time_stamp: store.state.time_stamp
    }
  }
  return config
})

axios.interceptors.response.use(config => {
  return config
}, error => {
  // 错误的请求结果处理
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = '错误请求'; console.log('错误请求');
        break
      case 401:
        error.message = '未授权，请重新登录'; console.log('未授权，请重新登录');
        window.location.href = store.state.login_url;
        break
      case 403:
        error.message = '拒绝访问'; console.log('拒绝访问');
        Vue.prototype.$inquiry();
        break
      case 404:
        error.message = '请求错误,未找到该资源'; console.log('请求错误,未找到该资源');
        break
      case 405:
        error.message = '请求方法未允许'; console.log('请求方法未允许');
        break
      case 408:
        error.message = '请求超时'; console.log('请求超时');
        break
      case 500:
        error.message = '服务器端出错'; console.log('服务器端出错');
        break
      case 501:
        error.message = '网络未实现'; console.log('网络未实现');
        break
      case 502:
        error.message = '网络错误'; console.log('网络错误');
        break
      case 503:
        error.message = '服务不可用'; console.log('服务不可用');
        break
      case 504:
        error.message = '网络超时'; console.log('网络超时');
        break
      case 505:
        error.message = 'http版本不支持该请求'; console.log('http版本不支持该请求');
        break
      default:
        error.message = `连接错误${error.response.status}`; console.log(`'连接错误'${error.response.status}`);
    }
  } else {
    error.message = "连接到服务器失败"; console.log('连接到服务器失败');
  }
  return Promise.reject(error)
})
Vue.prototype.$http = axios;